<template>
  <div style="padding: 20px">
    <div class="handle-box" style="display:flex;flex-wrap: wrap;margin-bottom: 20px">
      <el-button type="primary" style="margin-right: 10px" @click="insertDialog=true">新增</el-button>
      <el-select style="width: 150px" v-model="query.cityId" placeholder="城市" class="handle-select mr10">
        <el-option
            v-for="(item,index) in regionList" :key="index"
            :label="item.name"
            :value="item.id"></el-option>
      </el-select>
      <el-select placeholder="城市类型" style="width: 120px;margin-left: 10px" v-model="query.flag">
        <div>
          <el-option label="中招体育" value="1"></el-option>
          <el-option label="少年" value="2"></el-option>
          <el-option label="高考体育" value="4"></el-option>
          <el-option label="幼儿" value="5"></el-option>
        </div>
      </el-select>
      <el-select placeholder="任务日期" style="width: 120px;margin-left: 10px" v-model="query.day">
        <el-option
            v-for="day in 100"
            :key="day"
            :label="`${day}天`"
            :value="day"
        ></el-option>
      </el-select>
      <el-button type="primary" style="margin-left: 10px" @click="coachEntryTaskPageList">搜索</el-button>
      <el-button type="primary" @click="importDialog = true">导入</el-button>
    </div>

    <el-table
        :data="tableData"
        height="590px"
        border
        class="table"
        ref="multipleTable"
        :row-style="{height:9+'px'}"
        :cell-style="{padding:8+'px'}"
        header-cell-class-name="table-header">
      <el-table-column label="ID" align="center" show-overflow-tooltip prop="id" width="100"/>
      <el-table-column show-overflow-tooltip="true" label="日期" width="180">
        <template #default="scope">
          第{{scope.row.entryDay}}天任务
        </template>
      </el-table-column>
      <el-table-column label="任务" align="center" show-overflow-tooltip prop="task" width="600"/>
      <el-table-column label="序号" align="center" show-overflow-tooltip prop="sort" width="90"/>
      <el-table-column label="所属城市" width="320">
        <template #default="scope">
          <el-select style="width: 120px" v-model="scope.row.cityId" placeholder="城市">
            <el-option
                v-for="(item,index) in regionList" :key="index"
                :label="item.name"
                :value="item.id"></el-option>
          </el-select>
          <el-select placeholder="城市类型" style="width: 120px;margin-left: 10px" v-model="scope.row.flag">
            <div>
              <el-option label="中招体育" :value="1"></el-option>
              <el-option label="少年" :value="2"></el-option>
              <el-option label="高考体育" :value="4"></el-option>
              <el-option label="幼儿" :value="5"></el-option>
            </div>
          </el-select>
        </template>
      </el-table-column>

      <el-table-column show-overflow-tooltip="true" prop="addTime" label="添加时间"></el-table-column>
      <el-table-column fixed="right" label="操作" width="100" align="center">
        <template #default="scope">
          <el-button text type="primary" style="width: 14px;" size="small"
                     @click="updateDialog = true, updateData = JSON.parse(JSON.stringify(scope.row))">编辑
          </el-button>
          <el-button text type="primary" style="width: 14px;color: red" size="small"
                     @click="deleteEntryTask(scope.row.id)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--      element分页组件-->
    <div class="pagination">
      <el-pagination
          background
          layout="sizes, prev, pager, next, total"
          :current-page="query.pageIndex"
          :page-size="query.pageSize"
          :page-sizes="[100, 200, 300, 400]"
          :total="query.pageTotal"
          @current-change="handlePageChange"
          @size-change="handlePageSizeChange"
      ></el-pagination>
    </div>

    <el-dialog v-model="importDialog" title="导入任务" width="600">
      <div style="margin: 0 20px 20px 20px">
        <el-select style="width: 150px" v-model="importForm.cityId" placeholder="城市" class="handle-select mr10">
          <el-option
              v-for="(item,index) in regionList" :key="index"
              :label="item.name"
              :value="item.id"></el-option>
        </el-select>
        <el-select placeholder="城市类型" style="width: 120px;margin-left: 10px" v-model="importForm.flag">
          <div>
            <el-option label="中招体育" value="1"></el-option>
            <el-option label="少年" value="2"></el-option>
            <el-option label="高考体育" value="4"></el-option>
            <el-option label="幼儿" value="5"></el-option>
          </div>
        </el-select>
        <el-upload drag :limit="1" :auto-upload="false" :on-remove="handleRemove" style="margin-top: 20px"
                   :on-change="fileChange" :file-list="importForm.fileList">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>

      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="importDialog = false">取 消</el-button>
          <el-button type="primary" @click="confirmImport">确 定</el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog v-model="insertDialog" title="新增任务" width="700">
      <div>
        <el-select style="width: 150px" v-model="insertData.cityId" placeholder="城市" class="handle-select mr10">
          <el-option
              v-for="(item,index) in regionList" :key="index"
              :label="item.name"
              :value="item.id"></el-option>
        </el-select>
        <el-select placeholder="城市类型" style="width: 130px;margin-left: 10px" v-model="insertData.flag">
          <div>
            <el-option label="中招体育" value="1"></el-option>
            <el-option label="少年" value="2"></el-option>
            <el-option label="高考体育" value="4"></el-option>
            <el-option label="幼儿" value="5"></el-option>
          </div>
        </el-select>
        <el-select placeholder="任务日期" style="width: 160px;margin-left: 10px" v-model="insertData.entryDay">
          <el-option
              v-for="day in 100"
              :key="day"
              :label="`第${day}天的任务`"
              :value="day"
          ></el-option>
        </el-select>
        <el-input-number style="width: 160px;margin-left: 10px" v-model="insertData.sort" :min="1"  :max="1000" placeholder="序号"></el-input-number>
        <el-input style="margin-top: 20px"
            type="textarea"
            :rows="4"
            placeholder="请输入任务描述"
            v-model="insertData.task">
        </el-input>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="insertDialog = false">取 消</el-button>
          <el-button type="primary" @click="insertEntryTask">确 定</el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog v-model="updateDialog" title="编辑任务" width="700">
      <div>
        <el-select style="width: 150px" v-model="updateData.cityId" placeholder="城市" class="handle-select mr10">
          <el-option
              v-for="(item,index) in regionList" :key="index"
              :label="item.name"
              :value="item.id"></el-option>
        </el-select>
        <el-select placeholder="城市类型" style="width: 130px;margin-left: 10px" v-model="updateData.flag">
          <div>
            <el-option label="中招体育" :value="1"></el-option>
            <el-option label="少年" :value="2"></el-option>
            <el-option label="高考体育" :value="4"></el-option>
            <el-option label="幼儿" :value="5"></el-option>
          </div>
        </el-select>
        <el-select placeholder="任务日期" style="width: 160px;margin-left: 10px" v-model="updateData.entryDay">
          <el-option
              v-for="day in 100"
              :key="day"
              :label="`第${day}天的任务`"
              :value="day"
          ></el-option>
        </el-select>
        <el-input-number style="width: 160px;margin-left: 10px" v-model="updateData.sort" :min="1" :max="1000" placeholder="序号"></el-input-number>
        <el-input style="margin-top: 20px"
                  type="textarea"
                  :rows="4"
                  placeholder="请输入任务描述"
                  v-model="updateData.task">
        </el-input>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="updateDialog = false">取 消</el-button>
          <el-button type="primary" @click="updateEntryTask">确 定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {selectAreaByExpress} from "@/api/area";
import {importCoachEntryTask,coachEntryTaskPageList,updateEntryTask,insertEntryTask,deleteEntryTask} from "@/api/coach";
export default {
  name: "CoachNewbieTask",
  data() {
    return {
      insertDialog:false,
      insertData:{
        cityId:null,
        flag:null,
        entryDay:null,
        task:"",
        sort:null

      },
      updateDialog:false,
      updateData:{
        cityId:null,
        flag:null,
        entryDay:null,
        task:"",
        sort:null
      },
      importForm:{
        cityId:null,
        flag:null,
        fileList:[],
      },
      query:{
        cityId:null,
        flag:null,
        pageTotal:0,
        pageIndex: 1,
        pageSize: 50,
        day:null
      },
      tableData:[],
      importDialog:false,
      regionList:[],
    }
  },
  created() {
    this.coachEntryTaskPageList();
    selectAreaByExpress().then(res => {
      if (res.code == 200) {
        this.regionList = res.data
      } else {
        this.$message.error("获取城市数据失败");
      }
    })
  },
  methods:{
    deleteEntryTask(id){
      deleteEntryTask(id).then(val=>{
        if (val.code == 200) {
          this.coachEntryTaskPageList();
          this.$message.success("删除成功！");
        } else {
          this.$message.error(val.message);
        }
      })
    },
    insertEntryTask(){
      if (this.insertData.cityId == null || this.insertData.flag == null){
        this.$message.error("请完善表单！");return;
      }
      if (this.insertData.entryDay == null || this.insertData.task == "" || this.insertData.sort == null){
        this.$message.error("请完善表单！");return;
      }
      insertEntryTask(this.insertData).then(val=>{
        if (val.code == 200) {
          this.updateDialog = false;
          this.coachEntryTaskPageList();
          this.$message.success("新增成功！");
        } else {
          this.$message.error(val.message);
        }
      })
    },
    updateEntryTask(){
      if (this.updateData.cityId == null || this.updateData.flag == null){
        this.$message.error("请完善表单！");return;
      }
      if (this.updateData.entryDay == null || this.updateData.task == "" || this.updateData.sort == null){
        this.$message.error("请完善表单！");return;
      }
      updateEntryTask(this.updateData).then(val=>{
        if (val.code == 200) {
          this.updateDialog = false;
          this.coachEntryTaskPageList();
          this.$message.success("修改成功！");
        } else {
          this.$message.error(val.message);
        }
      })
    },
    handlePageSizeChange(size){
      this.query.pageSize=size;
      this.coachEntryTaskPageList();
    },
    handlePageChange(index){
      this.query.pageIndex=index;
      this.coachEntryTaskPageList();
    },
    confirmImport(){
      let item = this.importForm;
      if (item.cityId==null || item.flag == null || item.fileList.length<1){
        this.$message.error("请完善表单！");return
      }
      const data = new FormData()
      data.append('cityId', item.cityId);
      data.append('flag', item.flag);
      data.append('file', item.fileList[0]);
      importCoachEntryTask(data).then(val=>{
        if (val.code == 200) {
          this.importDialog=false;
          this.$message.success("导入成功！");
        } else {
          this.$message.error("导入失败！");
        }
      })
    },
    coachEntryTaskPageList(){
      coachEntryTaskPageList(this.query).then(val=>{
        if (val.code == 200){
          this.query.pageTotal = val.data.total;
          this.tableData = val.data.records;
        }
      })
    },
    handleRemove() {
      this.fileList = []
    },
    //文件状态改变时的钩子
    fileChange(file) {
      let extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      let size = file.size / 1024 / 1024;
      if (extension !== 'xlsx') {
        this.importForm.fileList = []
        this.$message.warning('只能上传后缀是.xlsx的文件');
      }
      if (size > 10) {
        this.importForm.fileList = []
        this.$message.warning('文件大小不得超过100M');
      }
      if (extension == 'xlsx') {
        this.importForm.fileList.push(file.raw);
      }
    },
  }
}
</script>

<style scoped>

</style>